import { render } from "./SmartFormula.vue?vue&type=template&id=5ddd5252"
import script from "./SmartFormula.vue?vue&type=script&lang=js"
export * from "./SmartFormula.vue?vue&type=script&lang=js"

import "./SmartFormula.vue?vue&type=style&index=0&id=5ddd5252&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__